<template>
  <div>
    <AtomLoadingSecondary v-show="showLoadingState"/>
    <div id="redirect"></div>

    <div v-show="Object.values(medio.parametros).length">
      <form
        autocomplete="off"
        class="m-form"
        @submit.prevent="createAcademiaPasarela"
      >
        <h3 class="m-form-title">
          {{ `${$t('mEditionBillingPaymentMethodsConnectMethod.title')} ${medio.nombre}` }}
        </h3>
        <div
          class="m-container-primary"
          id="params"
        >
        </div>
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
        <AtomButtonSecondary
          v-if="false"
          :button-secondary="buttonSecondary.reset"
        />
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionBillingPaymentMethodsConnectMethod',

  data () {
    return {
      academiaId: '',

      buttonPrimary: {
        action: this.$t('mEditionBillingPaymentMethodsConnectMethod.buttonPrimary'),
        class: 'margin-right-medium margin-top-medium',
        sending: false,
        type: 'submit'
      },

      buttonSecondary: {
        reset: {
          class: 'a-button-reset-secondary',
          component: '',
          icon: '',
          method: '',
          text: this.$t('aButtonSecondary.actions.reset'),
          type: 'reset'
        }
      },

      isValidPasarela: false,

      medio: {
        descripcion: '',
        nombre: '',
        parametros: {},
        pasarela: ''
      },

      showLoadingState: true
    }
  },

  created () {
    this.academiaId = this.$store.getters.getAcademyData.id
    if (Object.values(this.$store.getters.getBillingPaymentMethod).length) {
      this.medio.nombre = this.$store.getters.getBillingPaymentMethod.nombre
      this.medio.pasarela = this.$store.getters.getBillingPaymentMethod.id
    } else {
      this.$router.push(`/${this.$t('rPaths.billing')}/${this.$t('mEditionMenu.billing.paymentMethods.subject')}/${this.$t('mEditionMenu.billing.paymentMethods.children.selectMethod.subedition')}`)
    }
  },

  mounted () {
    this.readPasarelasConfiguracion()
  },

  methods: {
    createAcademiaPasarela () {
      this.setPasarelaCuenta()
      if (this.isValidPasarela && !this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$services.create('academia', 'createAcademiaPasarela', this.medio, [this.academiaId])
          .then(response => {
            this.$license.readAcademiaConfiguracionGlobal()
            this.$alerts.pushAlert('mEditionBillingPaymentMethodsConnectMethod', 'createAcademiaPasarela', 'success')
            this.$router.push(`/${this.$t('rPaths.billing')}/${this.$t('mEditionMenu.billing.paymentMethods.subject')}`)
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlert('mEditionBillingPaymentMethodsConnectMethod', 'createAcademiaPasarela', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
          })
      }
    },

    readPasarelasConfiguracion () {
      this.$services.read('pasarela', 'readPasarelasConfiguracion', {}, [this.medio.pasarela, this.academiaId])
        .then(response => {
          if (typeof response.data === 'object') {
            let form = ''
            form += `<div class="row">`
            form += `<div class="column column-8">`
            form += `<p class="a-input-wrapper-column margin-top-medium">`
            form += `<label for="descripcion">${this.$t('mEditionBillingPaymentMethodsConnectMethod.inputs.descripcion.label')}</label>`
            form += `<input id="descripcion" class="a-input-primary" name="descripcion" placeholder="${this.$t('mEditionBillingPaymentMethodsConnectMethod.inputs.descripcion.placeholder')}">`
            form += `<small id="descripcion-errormsg" class="display-none text-color-danger">${this.$t('mEditionBillingPaymentMethodsConnectMethod.validation.required')}</small></p></div></div>`
            for (const param in response.data) {
              form += `<div class="row">`
              form += `<div class="column column-8">`
              form += `<p class="a-input-wrapper-column">`
              form += `<label for="${param}">${response.data[param].label}</label>`
              form += `<input id="${param}" class="a-input-primary" name="${param}">`
              form += `<small id="${param}-errormsg" class="display-none text-color-danger">${this.$t('mEditionBillingPaymentMethodsConnectMethod.validation.required')}</small></p></div></div>`
              this.medio.parametros[param] = ''
            }
            document.getElementById('params').innerHTML = form
            document.getElementById('params').addEventListener('blur', (event) => {
              if (!event.target.value) {
                document.getElementById(`${event.target.id}-errormsg`).style.display = 'block'
                document.getElementById(event.target.id).classList.add('a-input-danger')
              } else {
                document.getElementById(`${event.target.id}-errormsg`).style.display = 'none'
                document.getElementById(event.target.id).classList.remove('a-input-danger')
              }
            }, true)
          } else {
            document.getElementById('redirect').innerHTML = `<div class="a-loading-secondary"><p>${this.$t('mEditionBillingPaymentMethodsConnectMethod.redirect')}</p></div>`
            window.open(response.data, '_blank')
            this.$router.go(-1)
          }
          this.showLoadingState = false
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState = false
        })
    },

    setPasarelaCuenta () {
      for (const param in this.medio.parametros) {
        this.medio.parametros[param] = document.getElementById(param).value
        if (document.getElementById(param).value === '') {
          document.getElementById(`${param}-errormsg`).style.display = 'block'
          document.getElementById(param).classList.add('a-input-danger')
        }
      }

      this.medio.descripcion = document.getElementById('descripcion').value
      if (document.getElementById('descripcion').value === '') {
        document.getElementById('descripcion-errormsg').style.display = 'block'
        document.getElementById('descripcion').classList.add('a-input-danger')
      }

      this.isValidPasarela = Object.values(this.medio.parametros).find(param => param === '') === undefined &&
        this.medio.pasarela !== '' && this.medio.descripcion !== ''
    }
  }
}
</script>
